import { createApp } from "vue";
import Router from "@/router/Router";
import DomainPlaceholder from "@/DomainPlaceholder.vue";

createApp(DomainPlaceholder).use(Router).mount("#domain-placeholder");
